import angular from "angular";

angular
	.module('app')
	.component('boomStreamLiveModal', {
		template: require('./boom-stream-live-modal.html'),
        controller: ['$http', '$sce', 'Notifier', controller],
        bindings: {
            resolve: '<',
            close: '&',
            dismiss: '&'
        }
    });

function controller($http, $sce, Notifier) {

    let $ctrl = this;

    $ctrl.$onInit = function () {
        $ctrl.lesson = $ctrl.resolve.lesson;
        $ctrl.course = $ctrl.resolve.course;
    };

    $ctrl.submit = () => {

        $ctrl.loading = true;

        $http.post(`/admin/courses/${$ctrl.course.id}/lessons/${$ctrl.lesson.id}/add-boom-stream-live`, {code: $ctrl.code})
            .then(
                function (response) {
                    $ctrl.loading = false;
                    $ctrl.close({
                        $value: {
                            html: response.data.html,
                            link: response.data.link,
                        }
                    });
                }, function (err) {
                    Notifier.error(err.data.message, 2);
                    $ctrl.loading = false;
                })
    }
}
